<template>
  <!--    DASHBOARD SIDEMENU-->
  <div class="dashboard-sidemenu">
    <a href="" @click.prevent="closeDashboardSidebar" class="close-s">
      <font-awesome-icon icon="times"></font-awesome-icon>
    </a>
    <div class="profile">
      <img
        :src="getUserDetails.profile_photo"
        v-if="getUserDetails.profile_photo"
      />
      <img src="/img/user-placeholder.png" v-else />
      <span class="squiggly-line-color line-center">{{
        getUserDetails.name
      }}</span>
    </div>
    <div
      v-bar="{
        preventParentScroll: true,
        scrollThrottle: 30
      }"
      class="vbar-height-sidebar"
    >
      <div class="dashboard-scroll">
        <ul class="list">
          <li class="item" @click="redirectToRoute('/student/dashboard')">
            <font-awesome-icon icon="th"></font-awesome-icon
            ><span>Dashboard</span>
          </li>
          <li class="item" @click="redirectToRoute('/student/my_courses')">
            <font-awesome-icon icon="chalkboard-teacher" /><span
              >My Courses</span
            >
          </li>
          <li class="item" @click="redirectToRoute('/student/edit_profile')">
            <font-awesome-icon icon="user-edit"></font-awesome-icon>
            <span>Edit profile</span>
          </li>
          <li
            class="item"
            @click="redirectToRoute('/student/following')"
            v-if="getUserRole === 'student'"
          >
            <font-awesome-icon icon="user-plus"></font-awesome-icon>
            <span>Following</span>
          </li>
          <li class="item" @click="redirectToRoute('/student/wishlist')">
            <font-awesome-icon icon="heart"></font-awesome-icon>
            <span>Wishlist</span>
          </li>
          <li
            class="item"
            @click="redirectToAdmin"
            v-if="getUserRole === 'teacher'"
          >
            <font-awesome-icon icon="plus-square"></font-awesome-icon>
            <span>Add Course</span>
          </li>
          <li class="item" @click="logOut">
            <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
            <span>Logout</span>
          </li>
        </ul>
        <p class="divider">Discover Courses</p>
        <ul class="list">
          <li class="item" @click="redirectToAllCourses">
            <!--<font-awesome-icon icon=""></font-awesome-icon>-->
            <span> All Courses </span>
          </li>
          <li
            class="item"
            v-for="sub in subjects"
            :key="sub.category_id"
            @click="redirectToRoute2(sub)"
          >
            <!--<font-awesome-icon icon=""></font-awesome-icon>-->
            <span>{{ sub.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { authenticationApi } from "../../services/authenticationApi";
import { commonFunctions } from "../../Commonjs/commonFunctions";

export default {
  name: "dashboard-side-menu",
  computed: {
    ...mapGetters("user", ["isAuthenticated", "getUserDetails", "getUserRole"]),
    ...mapGetters("category", ["getCategoryData"])
  },
  data() {
    return {
      subjects: []
    };
  },
  methods: {
    redirectToRoute(routePath) {
      this.closeDashboardSidebar();
      this.$router.push({
        path: routePath,
        query: {
          role: this.getUserRole
        }
      });
    },
    redirectToAllCourses() {
      this.closeDashboardSidebar();
      this.$router.push("/all_courses");
    },
    redirectToAdmin() {
      this.closeDashboardSidebar();
      // window.location.replace("https://edfore.techgentsia.com/app/#login");
      this.$router.push("/add_course");
    },
    redirectToRoute2(category) {
      this.closeDashboardSidebar();
      this.$router.push({
        path: "/courses",
        query: {
          categoryName: category.name,
          categoryId: category.category_id
        }
      });
    },
    closeDashboardSidebar() {
      commonFunctions.toggleDashboardSideBar();
      // const dash = document.querySelector(".dashboard-sidemenu");
      // const backdrop = document.querySelector(".dashboard-sidemenu-backdrop");
      // console.log("ssss");
      // if (dash.classList.contains("shown")) {
      //   dash.classList.remove("shown");
      //   backdrop.classList.remove("shown");
      //   document.body.classList.remove("modal-open");
      // } else {
      //   return 0;
      // }
    },
    logOut() {
      authenticationApi
        .logOut()
        .then(res => {
          // if (this.$route.meta.requiredAuth) {
          //   if (this.$route.path === "/course_subscription") {
          //     this.$router.back();
          //   } else {
          //     this.$router.push("/");
          //   }
          // }
          this.$router.push("/");
          this.$bvToast.toast("Logout successful", {
            title: "Logout",
            variant: "success",
            autoHideDelay: 500,
            appendToast: true
          });
        })
        .catch(e => {
          this.$bvToast.toast("Error Occurred while logging out", {
            title: "Logout",
            variant: "danger",
            autoHideDelay: 500,
            appendToast: true
          });
        });
    }
  },
  mounted() {
    this.getCategoryData.forEach(category => {
      category.sub_category.forEach(sub => {
        this.subjects.push(sub);
      });
    });
  }
};
</script>

<style scoped></style>
